import type { DateRange } from 'react-day-picker'
import { FLIGHT_TYPE_OPTIONS } from '../constants'

// Form handler utility functions
export const onCalendarChange = (
  dates: Date | Date[] | DateRange | undefined
): void => {
  // eslint-disable-next-line no-console
  console.log('Flight dates clicked', dates)
}

export const createRadioOptions = () => {
  return FLIGHT_TYPE_OPTIONS.map(option => ({
    value: option.value,
    labelNode: option.label,
    name: 'flightType'
  }))
}

export const handleFlightTypeChange = (
  value: unknown,
  setFlightType: (value: string) => void
): void => {
  setFlightType(value as string)
  // eslint-disable-next-line no-console
  console.log('Flight type changed to:', value)
}

export const createToggleHandler = (
  currentValue: boolean,
  setValue: (value: boolean) => void
) => {
  return () => setValue(!currentValue)
}
